module.exports = __webpack_public_path__ + "img/logoFinalMK.c81abd61.gif";